define([
    "jquery",
    "underscore",
	"backbone",
	"google_analytics"
], function($, _, Backbone, GoogleAnalytics) {

    return Backbone.View.extend({
        el: '#content_layout',

        events:{
			'click .print_btn': 'print'
        },

        initialize: function(){
            if(window.lang === 'ja_JP')
            {
                GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_bankwire_open_jp);
            }
		},
    });
});
